/** Title-case each word in a person name (e.g. "nico creemers" → "Nico Creemers"). */
export function formatPersonName(name) {
  if (!name || typeof name !== 'string') return '';

  return name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((word) =>
      word
        .split('-')
        .map((part) => (part ? part.charAt(0).toUpperCase() + part.slice(1).toLowerCase() : ''))
        .join('-')
    )
    .join(' ');
}

/** Format a person from first/last/email fields. */
export function formatAdvisorNameFromFields(
  { first_name, last_name, firstName, lastName, email, name } = {},
  fallback = '',
) {
  const fromParts = formatPersonName(
    `${first_name || firstName || ''} ${last_name || lastName || ''}`.trim(),
  );
  if (fromParts) return fromParts;
  if (name) {
    const formatted = formatPersonName(String(name));
    if (formatted) return formatted;
  }
  if (email) return String(email).trim();
  return fallback;
}

/**
 * Advisor on PDF cover = quote creator (not the person currently logged in / sending).
 * Prefers API creator fields from quotes.created_by, then stored quoteCreator snapshot,
 * then optional fallback user (only for brand-new quotes that have not been persisted yet).
 */
export function resolveQuoteAdvisorName(
  {
    quoteCreator = null,
    creator_first_name = '',
    creator_last_name = '',
    creator_email = '',
    fallbackUser = null,
  } = {},
  fallback = '',
) {
  const fromApi = formatAdvisorNameFromFields(
    {
      first_name: creator_first_name,
      last_name: creator_last_name,
      email: creator_email,
    },
    '',
  );
  if (fromApi) return fromApi;

  const fromCreator = formatAdvisorNameFromFields(quoteCreator || {}, '');
  if (fromCreator) return fromCreator;

  return formatAdvisorName(fallbackUser, fallback);
}

/** Logged-in team member name (legacy helper; prefer resolveQuoteAdvisorName for PDFs). */
export function formatAdvisorName(user, fallback = '') {
  if (!user) return fallback;
  return formatAdvisorNameFromFields(user, fallback);
}
